import { ControllersDataItem } from '../../logic/main/types';

export const getGroupedCodesFromJPTiles = (
  components: ControllersDataItem['components']
) => {
  const groupedJPCodes = components
    .map(getJPCodeAndProvider)
    .filter(Boolean)
    .reduce(groupJackpotCodesByProviders, {});

  return Object.entries<string[]>(groupedJPCodes);
};

const getJPCodeAndProvider = ([id, { properties }]: [
  string,
  { properties: any }
]) =>
  properties.jackpot_tile && {
    provider: properties.jackpot_tile.provider,
    code: properties.jackpot_tile.code,
  };

const groupJackpotCodesByProviders = (
  groupedJPCodes: Record<string, string[]>,
  { provider, code }: { provider: string; code: string }
) => ({
  ...groupedJPCodes,
  [provider]: groupedJPCodes[provider]
    ? [...groupedJPCodes[provider], code]
    : [code],
});
